import { apiClient } from './apiClient'

export const deviceFormApi = {
    fetchDeviceForms: async (businessEntityId, filters, config, accessToken) => {
        let print = false
        return await apiClient(
            `${config.managementApiUrl}/businessentities/${businessEntityId}/componentDeviceForms`,
            accessToken,
            {
                method: 'GET'
            },
            async (response) => {
                return await response.json().then(
                    (rt) => {
                        if (print) {
                            console.log("Fetched the following device forms:")
                            console.log(rt.componentDeviceForm)
                        }
                        return rt.componentDeviceForm
                    }
                )
            }
        )
    },
    createDeviceForm: async (businessEntityId, form, config, accessToken) => {
        const url = `${config.managementApiUrl}/businessentities/${businessEntityId}/componentDeviceForms/create`
        return await apiClient(
            url,
            accessToken,
            {
                method: "POST",
                body: JSON.stringify(form)
            },
            (response) => {
                return response.json()
            }
        )
    },
    deleteDeviceForm: async (businessEntityId, recordId, config, accessToken) => {
        const url = `${config.managementApiUrl}/businessentities/${businessEntityId}/componentDeviceForms/${recordId}`
        return await apiClient(
            url,
            accessToken,
            {
                method: "POST",
                headers: {
                    'X-HTTP-Method-Override': 'DELETE'
                }
            },
            (response) => {
                return response
            }
        )

    },
    downloadDeviceForm: async (businessEntityId, recordId, fileExtension, config, accessToken) => {
        let url = `${config.managementApiUrl}/businessentities/${businessEntityId}/componentDeviceForms/${recordId}/forms.${fileExtension}`
        return await apiClient(
            url,
            accessToken,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            },
            (response) => {
                return response
            }
        )
    },
    updateDeviceFormUploadStatus: async (businessEntityId, formId, config, accessToken) => {
        const url = `${config.managementApiUrl}/businessentities/${businessEntityId}/componentDeviceForms/${formId}/uploaded`
        return await apiClient(
            url,
            accessToken,
            {
                method: 'PUT'
            },
            (response) => {
                return response
            }
        )
    }
}